// Phase 5Z.9 — Fahrer-Auth context
import { createContext, useContext, useEffect, useState } from "react";
import { fahrerMe, fahrerToken, fahrerLogout as apiLogout } from "./api";

const FahrerAuthContext = createContext(null);

export function FahrerAuthProvider({ children }) {
  const [me, setMe] = useState(null);     // null = unknown, false = unauthenticated, object = driver
  const [loading, setLoading] = useState(true);

  async function refresh() {
    if (!fahrerToken.get()) {
      setMe(false);
      setLoading(false);
      return;
    }
    try {
      const data = await fahrerMe();
      setMe(data);
    } catch {
      fahrerToken.clear();
      setMe(false);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => { refresh(); }, []);

  async function logout() {
    await apiLogout();
    setMe(false);
  }

  return (
    <FahrerAuthContext.Provider value={{ me, setMe, loading, refresh, logout }}>
      {children}
    </FahrerAuthContext.Provider>
  );
}

export function useFahrerAuth() {
  return useContext(FahrerAuthContext);
}
